module.exports = __webpack_public_path__ + "static/pic10.fc2217a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic10.jpg
// module id = 134
// module chunks = 65868693374900 154382131621592